import { Chip } from '@mui/material';
import React from 'react';

const BETA_CHIP_BACKGROUND_COLOR = '#BDDEFF';
const BETA_CHIP_TEXT_COLOR = '#001931';

export const BetaChip = (): React.ReactElement => (
    <Chip
        label="Beta"
        size="small"
        sx={{
            height: 20,
            backgroundColor: BETA_CHIP_BACKGROUND_COLOR,
            color: BETA_CHIP_TEXT_COLOR,
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            '& .MuiChip-label': { px: 1.5 },
        }}
    />
);
